import script from "./flash-growth-login.vue?vue&type=script&setup=true&lang=js"
export * from "./flash-growth-login.vue?vue&type=script&setup=true&lang=js"

import "./flash-growth-login.vue?vue&type=style&index=0&id=12f733f1&lang=css"

const __exports__ = script;

export default __exports__